import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

interface HeaderButtonProps {
    groupHeaderName: string;
    isGroupVisible: boolean;
    toggleGroupVisibility: (groupHeaderName: string) => void;
    noButton?: boolean;
};

const boxStyleOuter = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '200vw',
};

const HeaderButton: React.FC<HeaderButtonProps> = ({ groupHeaderName, isGroupVisible, toggleGroupVisibility, noButton }) => {
    const callback = () => {
        toggleGroupVisibility(groupHeaderName)
    };

    return (
        <Box sx={boxStyleOuter}>
            <Typography sx={{ fontWeight: 'bold' }} variant="subtitle2">{groupHeaderName}</Typography>
            {noButton ? null : (
                <Button size="small" variant="outlined" color="primary" onClick={callback}>
                    {isGroupVisible ? (
                        <ChevronLeftIcon />
                    ) : (
                        <ChevronRightIcon />
                    )}
                </Button>
            )}
        </Box>
    );
};

export default HeaderButton;